import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { TableRowColumn, TableRow } from 'material-ui/Table';
import {
  ASSIGNED,
  NOT_ASSIGNED,
  SHOULD_BE_ASSIGNED,
  SHOULD_BE_UNASSIGNED,
} from '../../constants';

const AssignPathologistsTableRow = ({
  name,
  role,
  key,
  status,
  index,
  handleClick,
  canUpdateAssignedPathologists,
}) => {
  const rowNum = index + 1;
  const lowerCaseString = (string) => string.toLowerCase();

  const nameStyling = {
    textTransform: 'capitalize',
  };

  let label = null;
  let actionTitle = null;
  let rowStyling = null;

  switch (status) {
    case ASSIGNED:
      label = 'Remove assignment';
      actionTitle = `Unassign ${name} from case`;
      rowStyling = { backgroundColor: '#b8b8da8a' };
      break;
    case SHOULD_BE_ASSIGNED:
      label = 'Remove assignment';
      actionTitle = `Regret assigning ${name} case`;
      rowStyling = { backgroundColor: '#b8b8da3b' };
      break;
    case NOT_ASSIGNED:
      label = 'Assign to case';
      actionTitle = `Assign ${name} to case`;
      rowStyling = {};
      break;
    case SHOULD_BE_UNASSIGNED:
      label = 'Assign to case';
      actionTitle = `Regret unassigning ${name} from case`;
      rowStyling = {};
      break;
    default:
      label = 'Status not available';
      actionTitle = 'Not available';
      rowStyling = {};
      return null;
  }

  return (
    <React.Fragment>
      <TableRow key={key} style={rowStyling}>
        <TableRowColumn >
          <span>{rowNum}</span>
        </TableRowColumn>

        <TableRowColumn colSpan="2">
          <span style={nameStyling}>{lowerCaseString(name)}</span>
        </TableRowColumn>

        {/* The role/type row isn't part of the prototype, it's used during development.  */}
        <TableRowColumn>
          <span>{role}</span>
        </TableRowColumn>

        <TableRowColumn colSpan="2">
          <RaisedButton
            disabled={!canUpdateAssignedPathologists}
            onClick={handleClick}
            fullWidth
            label={label}
            title={actionTitle} 
            />
        </TableRowColumn>

        {/* The status row isn't part of the prototype, it's used during development.  */}
        <TableRowColumn >
          <span>{lowerCaseString(status)}</span>
        </TableRowColumn>
      </TableRow>
    </React.Fragment>
  );
};

export default AssignPathologistsTableRow;
